// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","box":"NotFound_box__80rz3","boxText":"NotFound_boxText__tDk7e","boxSubText":"NotFound_boxSubText__dAXhz","buttons":"NotFound_buttons__X7VZt"};